import { Button, Col, Flex, Modal, Row, Space } from "antd";
import TableAntd from "components/elements/Table";
import { FormInput } from "components/form/FormProvide";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SendNotiToModal = ({
    isModalOpen = false,
    setIsModalOpen = () => { },
}) => {
    const { t, i18n } = useTranslation();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [pagination, setPagination] = useState({ page: 0, size: 10 });

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const hasSelected = selectedRowKeys?.length > 0;

    const handleCancel = () => {
        setSelectedRowKeys([]);
        setIsModalOpen(false);
    };

    const columns = [
        {
            title: <div className="text-table">{t("user_management.label.employee_id")}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
        },
        {
            title: <div className="text-table">{t("employee.label.name")}</div>,
            dataIndex: "fullName",
            key: "fullName",
        },
        {
            title: "",
            key: "action",
            width: '40px',
            fixed: "right",
            align: "center",
            // render: (_, record) => (
            //     console.log("recordrecord", record),
            //     <Space size="middle">
            //         <Dropdown
            //             menu={{
            //                 items: [
            //                     {
            //                         key: "1",
            //                         onClick: () => onViewSlip(record),
            //                         label: t("payroll.label.view_slip"),
            //                         icon: (
            //                             <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
            //                         ),
            //                     },
            //                     (Number(record?.approveStatusCode) >= '2' && {
            //                         key: "2",
            //                         onClick: () => sendingSalaryCertificateByIdFn(record),
            //                         label: t("payroll.label.send_slip"),
            //                         icon: (
            //                             <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
            //                         ),
            //                     }),
            //                     {
            //                         key: "3",
            //                         onClick: () => onDownloadSlip(record),
            //                         label: t("payroll.label.download_slip"),
            //                         icon: (
            //                             <DownloadOutlined style={{ fontSize: "18px", color: "gray" }} />
            //                         ),
            //                     },

            //                 ],
            //             }}
            //         >
            //             <MoreOutlined style={{ inlineSize: "20px", fontSize: "25px", color: "gray" }} />
            //         </Dropdown>
            //     </Space>
            // ),
        },
    ]

    const dataSource = Array.from({ length: 5 }).map((_, i) => ({
        key: i,
        employeeNo: `Edward King ${i}`,
        fullName: `London, Park Lane no. ${i}`,
    }));

    return (
        <Modal
            title={t("setting_notification.send_to")}
            open={isModalOpen}
            closable={false}
            maskClosable={false}
            width={620}
            footer={false}
            destroyOnClose
        >
            <Space direction="vertical" size={24}>
                <Row justify={"space-between"}>
                    <Col span={11}>
                        <FormInput
                            name="employeeId"
                            label={t("employee.label.employee_no")}
                            placeholder={t("common.please_fill")}
                            size="large"
                        />
                    </Col>
                    <Col span={11}>
                        <FormInput
                            name="fullName"
                            label={t("employee.label.name")}
                            placeholder={t("common.please_fill")}
                            size="large"
                        />
                    </Col>
                </Row>
                <TableAntd
                    columns={columns}
                    rowSelection={rowSelection}
                    dataSource={dataSource}
                    pagination={{
                        ...pagination,
                        showTotal: (total, range) =>
                            t("paginate.description")
                                .replace("{min}", range[0])
                                .replace("{max}", range[1])
                                .replace("{total}", total),
                    }}
                    rowKey={(record) => record.key}
                />
                <Flex vertical justify="end" align="end" gap={8}>
                    {hasSelected ? i18n.language == "en"
                        ? `Number of employees selected : ${selectedRowKeys?.length}`
                        : `จำนวนพนักงานที่เลือก ${selectedRowKeys?.length} คน`
                        : null}
                    <Flex gap={8}>
                        <Button
                            type="default"
                            style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                            onClick={() => { handleCancel() }}
                        >
                            {t("common.cancel")}
                        </Button>

                        <Button
                            type="primary"
                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color", fontWeight: "bold" }}
                        >
                            {t("common.save")}
                        </Button>
                    </Flex>
                </Flex>
            </Space>
        </Modal>
    )
}

export default SendNotiToModal;